import { getSocialList } from '@hhgtech/hhg-components/misc'
import { SocialType } from '@hhgtech/hhg-components/types'

import { getHelloSitesUrl } from 'api/utils/paths'
import { LOCALE } from 'interfaces/types'

import { SocialItem } from './types'

export const getSocialListByLocale = (
  locale: LOCALE,
  shareUrl: string,
  iconSize = 32,
  isMobile?: boolean,
) => {
  const sortList =
    locale === LOCALE.Taiwan
      ? [SocialType.Line, SocialType.Facebook]
      : locale === LOCALE.Malaysia
      ? [SocialType.Facebook, SocialType.WhatsApp, SocialType.LinkedIn]
      : locale === LOCALE.Cambodia
      ? [SocialType.Facebook, SocialType.LinkedIn]
      : locale === LOCALE.Myanmar
      ? [SocialType.Facebook, SocialType.LinkedIn]
      : locale === LOCALE.Vietnam
      ? isMobile
        ? [
            SocialType.Facebook,
            SocialType.Zalo,
            SocialType.Twitter,
            SocialType.LinkedIn,
          ]
        : [
            SocialType.Facebook,
            SocialType.Twitter,
            SocialType.LinkedIn,
            SocialType.Zalo,
          ]
      : locale === LOCALE.Indonesia
      ? [
          SocialType.Facebook,
          SocialType.WhatsApp,
          SocialType.Twitter,
          SocialType.LinkedIn,
        ]
      : locale === LOCALE.Thailand
      ? [SocialType.Facebook, SocialType.LinkedIn]
      : locale === LOCALE.PhilippinesEnglish ||
        locale === LOCALE.PhilippinesTagalog
      ? [SocialType.Facebook, SocialType.LinkedIn]
      : locale === LOCALE.India
      ? [SocialType.Facebook, SocialType.LinkedIn]
      : [SocialType.Facebook, SocialType.LinkedIn]
  const listByType: { [key in SocialType]?: SocialItem } = {}
  const avaiList = getSocialList({ shareUrl, size: iconSize, locale }).filter(
    (s) => {
      if ((!s.allowedLocales || s.allowedLocales.includes(locale)) && s.href) {
        listByType[s.type] = {
          ...s,
          ...(s.type === SocialType.LinkedIn
            ? {
                href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                  formatShareUrl(shareUrl, locale, SocialType.LinkedIn),
                )}`,
              }
            : s.type === SocialType.Facebook
            ? {
                href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  formatShareUrl(shareUrl, locale, SocialType.Facebook),
                )}`,
              }
            : s.type === SocialType.Zalo
            ? {
                href: formatShareUrl(shareUrl, locale, SocialType.Zalo),
              }
            : s.type === SocialType.Twitter
            ? {
                href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  formatShareUrl(shareUrl, locale, SocialType.Twitter),
                )}`,
              }
            : s.type === SocialType.WhatsApp
            ? {
                href: `https://wa.me/?text=${encodeURIComponent(
                  formatShareUrl(shareUrl, locale, SocialType.WhatsApp),
                )}`,
              }
            : s.type === SocialType.Line
            ? {
                href: `http://line.me/R/msg/text/?${encodeURIComponent(
                  formatShareUrl(shareUrl, locale, SocialType.Line),
                )}`,
              }
            : {}),
        }
        return s
      }
    },
  )
  return Array.isArray(sortList) && sortList.length > 0
    ? (() => {
        const tmp: SocialItem[] = []
        sortList.map((i) => {
          if (listByType?.[i]?.href) {
            tmp.push(listByType[i] as SocialItem)
          }
        })
        return tmp
      })()
    : avaiList
}

function formatShareUrl(url: string, locale: LOCALE, channel?: SocialType) {
  const fullUrl = url.startsWith('http')
    ? url
    : `${getHelloSitesUrl(locale, true)}${url}`
  return channel
    ? (() => {
        try {
          const newUrl = new URL(fullUrl)
          newUrl.searchParams.append('cn', channel)
          return newUrl.toString()
        } catch (err) {
          return fullUrl
        }
      })()
    : fullUrl
}
